export const PATH = '/preferences';
export const PAGE_TITLE = 'Preferências';
export const LANGUAGES: { [key: string]: string } = {
    'pt-BR': 'Português',
    'en-US': 'English',
    'es-ES': 'Español',
};
